import { formatCurrency, getArrFromObj } from "@ashirbad/js-core";
import MaterialTable from "@material-table/core";
import { Group, Person, ShoppingCart } from "@mui/icons-material";
import { Avatar, Button, Grid } from "@mui/material";
import { database } from "configs/firebaseConfigs";
import { onValue, ref } from "firebase/database";
import { useIsMounted } from "hooks";
import useDataFetch from "hooks/useDataFetch";
import moment from "moment";
import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { muiTable } from "utils";

const ViewUser = () => {
  const [user, setUser] = useState(null);
  const [orderedData, setOrderedData] = useState([]);
  const [wishlistData, setWishlistData] = useState([]);

  const { id } = useParams();

  const orderData = useDataFetch(`/orders/${id}`);

  const isMounted = useIsMounted();

  const navigate = useNavigate();

  useEffect(() => {
    if (isMounted.current) {
      onValue(ref(database, `users/${id}`), (snap) => {
        if (snap.exists()) {
          let data = snap.val();
          setUser(data);
        }
      });
    }
  }, [id, isMounted]);
  useEffect(() => {
    if (isMounted.current) {
      if (!orderData.data) return;
      let data = orderData.data;
      let orderDetails = [];
      let sl = 1;

      data?.map((order) => {
        // console.log(order);
        return order?.products?.map((product) => {
          orderDetails.push({
            ...order,
            products: product,
            sl,
            orderId: order.id,
            id: order.id + "-" + sl,
          });
          sl++;
          return null;
        });
      });
      setOrderedData(orderDetails);
    }
  }, [orderData?.data, isMounted]);

  useEffect(() => {
    if (isMounted.current) {
      onValue(ref(database, `wishlist/${id}`), (snap) => {
        if (snap.exists()) {
          let data = getArrFromObj(snap.val());

          setWishlistData(data);
        }
      });
    }
  }, [id, isMounted]);

  // console.log(orderedData);

  return (
    <section className="dashboard-user-details">
      <Grid container spacing={1}>
        <Grid
          item
          xs={12}
          sm={6}
          md={4}
          sx={{
            borderRight: "1px solid #e0e0e0",
          }}
        >
          <div className=" flex-column align-items-center justify-content-center gap-2 user-profile-section">
            <Avatar
              src={`https://avatars.dicebear.com/api/avataaars/${user?.displayName}.svg`}
              sx={{
                height: "8rem",
                width: "7rem",
                backgroundColor: "#efefef",
                borderRadius: "10px",
              }}
            />
            <span className="flex-column align-items-center gap-1">
              <h3 className="dashboard-user-title">{user?.displayName}</h3>
              <h4 className="dashboard-user-email">{user?.email}</h4>
            </span>
          </div>
          {/* <div className="w-100 flex-row align-items-center gap-1 justify-content-between user-stat-container ">
            <span className="flex-column gap-1 align-items-center dashboard-user-stat ">
              <h3> {orderedData?.length} </h3>
              <h5>Bought</h5>
            </span>
            <span className="flex-column gap-1 align-items-center dashboard-user-stat ">
              <h3> {wishlistData?.length} </h3>
              <h5>Wish List</h5>
            </span>
            <span className="flex-column gap-1 align-items-center dashboard-user-stat ">
              <h3>1150</h3>
              <h5>Following</h5>
            </span>
          </div> */}
          <div className="dashboard-user-contact-info flex-column gap-2">
            <h3 className="contact-info-title  ">Contact Information</h3>
            <span className="w-100 flex-column ">
              <h3>Email Address</h3>
              <h4>{user?.email}</h4>
            </span>
            <span className="w-100 flex-column ">
              <h3>Phone Number</h3>
              <h4>{user?.phoneNumber}</h4>
            </span>
            <span className="w-100 flex-column ">
              <h3>Birthday</h3>
              <h4>{user?.dateOfBirth}</h4>
            </span>
          </div>
        </Grid>
        <Grid item xs={12} sm={6} md={8}>
          <div className="dashboard-user-card-container flex-row align-items-center justify-content-between flex-wrap gap-2">
            <span className="user-details-card flex-row gap-2 ">
              <span
                className="user-icon-box"
                style={{
                  backgroundColor: "#d94667",
                }}
              >
                <Person
                  sx={{
                    height: "3rem",
                    width: "3rem",
                    color: "#ffffff",
                  }}
                />
              </span>

              <span className="flex-column ">
                <h3>{orderedData?.length} </h3>
                <h4>Bought</h4>
              </span>
            </span>
            <span className="user-details-card flex-row gap-2 ">
              <span
                className="user-icon-box"
                style={{
                  backgroundColor: "#ffc107",
                }}
              >
                <ShoppingCart
                  sx={{
                    height: "3rem",
                    width: "3rem",
                    color: "#ffffff",
                  }}
                />
              </span>

              <span className="flex-column ">
                <h3>{wishlistData?.length} </h3>
                <h4>Wishlist</h4>
              </span>
            </span>
            <span className="user-details-card flex-row gap-2 ">
              <span
                className="user-icon-box"
                style={{
                  backgroundColor: "#28a745",
                }}
              >
                <Group
                  sx={{
                    height: "3rem",
                    width: "3rem",
                    color: "#ffffff",
                  }}
                />
              </span>

              <span className="flex-column ">
                <h3> {getArrFromObj(user?.referred)?.length} </h3>
                <h4>Refereed</h4>
              </span>
            </span>
          </div>
          <div
            className="w-100"
            style={{
              marginTop: "2rem",
            }}
          >
            <MaterialTable
              title="User Purchases"
              isLoading={!orderData?.data && orderData?.loading}
              data={orderedData || []}
              options={{ ...muiTable.options() }}
              style={muiTable.styles}
              columns={[
                {
                  title: "#",
                  field: "sl",
                  width: "5%",
                  editable: "never",
                  id: "sl",
                },
                {
                  title: "Product",
                  field: "product",
                  render: (rowData) => (
                    <Avatar
                      src={rowData?.products?.productImg}
                      variant="rounded"
                      sx={{ width: 60, height: 60 }}
                    />
                  ),
                  width: "5%",
                },
                {
                  title: "Name",
                  field: "products.productName",
                  emptyValue: "Value not found",
                  render: (rowData) => {
                    return <span>{rowData?.products?.productName}</span>;
                  },
                },
                {
                  title: "Price",
                  field: "products",
                  render: ({ products }) => {
                    return formatCurrency(products?.price, "SAR");
                  },
                },

                {
                  title: "Purchased On",
                  field: "createdAt",
                  render: (rowData) => {
                    return moment(rowData?.createdAt).fromNow();
                  },
                },
                {
                  title: "Status",
                  field: "status",
                },
                {
                  title: "Invoice",
                  field: "delivered",
                  emptyValue: "No Invoice",
                  render: (rowData) => {
                    return rowData?.delivered ? (
                      <Button
                        sx={{
                          backgroundColor: "#28a745",
                          color: "#ffffff",
                          borderRadius: "7px",
                          width: "100%",
                          ":hover": {
                            backgroundColor: "#28a745",
                            color: "#ffffff",
                          },
                        }}
                        onClick={() => {
                          navigate(`/admin/invoices/${rowData?.orderId}`);
                        }}
                      >
                        View
                      </Button>
                    ) : (
                      <span>No Invoice</span>
                    );
                  },
                },
              ]}
            />
          </div>
        </Grid>
      </Grid>
    </section>
  );
};

export default ViewUser;
